import axios, { AxiosError } from 'axios';
import { ErrorResponse } from 'react-router-dom';

const API_BASE_URL = import.meta.env.VITE_API;

/**
 * Configuration de l'instance axios avec l'URL de base
 */
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials:true
});

/**
 * Intercepteur pour ajouter automatiquement le token d'authentification à chaque requête
 */
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

/**
 * Fonction fetcher pour SWR qui gère les erreurs et formate les réponses
 * @param url - URL de l'endpoint à appeler
 * @returns Données formatées de la réponse
 */
export const fetcher = async (url: string) => {
  try {
    const res = await apiClient.get(url);
    console.log("Données récupérées:", res.data);
    return res.data;
  } catch (error) {
    console.error("Erreur dans fetcher SWR:", error);
    // Pour les tickets, retourner un tableau vide en cas d'erreur
    if (url.includes('/ticket')) {
      return { isSuccess: false, data: [], errorMessage: "Erreur de chargement" };
    }
    throw error;
  }
};

/**
 * Génère l'URL pour récupérer tous les tickets d'une entreprise
 */
export const getTicketsUrl = (companyId: string) => `/Company/${companyId}/ticket`;

/**
 * Génère l'URL pour récupérer un ticket spécifique
 */
export const getTicketByIdUrl = (ticketId: string) => 
  `/Company/ticket/${ticketId}`;

/**
 * Génère l'URL pour les commentaires d'un ticket
 * Note: Cette fonction peut être omise si les commentaires sont déjà inclus dans la réponse du ticket
 */
export const getTicketCommentsUrl = (companyId: string, ticketId: string) => 
  `/Company/${companyId}/ticket/${ticketId}/comment`;


/**
 * Crée un nouveau ticket
 * @param companyId - ID de l'entreprise
 * @param ticketData - Données du ticket à créer
 */
export const createTicket = async (
  companyId: string,
  ticketData: {
    title: string;
    description: string;
    type: string;
    priority: string;
    createdBy?: string | null;
    status?: string | null;
    companyId?: number | null;
  }
): Promise<any> => {
  try {
    const response = await apiClient.post(`/Company/${companyId}/ticket`, {
      title: ticketData.title,
      description: ticketData.description,
      type: ticketData.type,
      priority: ticketData.priority,
      createdBy: ticketData.createdBy || null,
      status: ticketData.status ,
      companyId: ticketData.companyId || null,
    });
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError<ErrorResponse>;
    console.error("Erreur lors de la création du ticket:", axiosError.response);
    throw axiosError.response?.data || { message: "Une erreur inattendue est survenue." };
  }
};

/**
 * Met à jour le statut d'un ticket
 * @param companyId - ID de l'entreprise
 * @param ticketId - ID du ticket
 * @param status - Nouveau statut du ticket
 */
export const updateTicketStatus = async (
  companyId: string,
  ticketId: string,
  status: string
): Promise<any> => {
  try {
    const response = await apiClient.post(`/Company/${companyId}/ticket/${ticketId}/status`, {
      ticketId: parseInt(ticketId),
      status: status
    });
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError<ErrorResponse>;
    console.error("Erreur lors de la mise à jour du statut:", axiosError.response);
    throw axiosError.response?.data || { message: "Une erreur inattendue est survenue." };
  }
};

/**
 * Ajoute un commentaire à un ticket
 * @param companyId - ID de l'entreprise
 * @param ticketId - ID du ticket
 * @param commentData - Données du commentaire à ajouter
 */
export const addTicketComment = async (
  companyId: string,
  ticketId: string,
  commentData: {
    author: string;
    message: string;
  }
): Promise<any> => {
  try {
    const response = await apiClient.post(`/Company/${companyId}/ticket/${ticketId}/comment`, {
      ticketId: parseInt(ticketId),
      author: commentData.author,
      message: commentData.message,
      createdAt: new Date().toISOString()
    });
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError<ErrorResponse>;
    console.error("Erreur lors de l'ajout du commentaire:", axiosError.response);
    throw axiosError.response?.data || { message: "Une erreur inattendue est survenue." };
  }
};

// import axios, { AxiosError } from 'axios';
// import { ErrorResponse } from 'react-router-dom';

// const API_BASE_URL = import.meta.env.VITE_API;

// // Créer une instance axios avec les headers communs
// const apiClient = axios.create({
//   baseURL: API_BASE_URL,
// });

// // Intercepteur pour ajouter le token à chaque requête
// apiClient.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem('access_token');
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // Fonction fetcher pour SWR améliorée pour gérer correctement les erreurs et garantir un tableau pour les tickets
// export const fetcher = (url: string) => 
//   apiClient.get(url)
//     .then(res => 
//       {
//         console.log("userdetail", res.data);
//         return res.data;
//       })
//     .catch(error => {
//       console.error("Erreur dans fetcher SWR:", error);
//       // Si on récupère des tickets, retourner un tableau vide en cas d'erreur
//       if (url.includes('/ticket')) {
//         return { isSuccess: false, data: [], errorMessage: "Erreur de chargement" };
//       }
//       throw error;
//     });

// // API endpoints pour récupérer les tickets
// export const getTicketsUrl = (companyId: string) => `/Company/${companyId}/ticket`;

// export const getTicketByIdUrl = (companyId: string, ticketId: string) => `/Company/${companyId}/ticket/${ticketId}`;

// export const getTicketCommentsUrl = (companyId: string, ticketId: string) => `/Company/${companyId}/ticket/${ticketId}/comment`;

// // Création d'un ticket
// export const createTicket = async (
//   companyId: string,
//   ticketData: {
//     title: string;
//     description: string;
//     type: string;
//     priority: string;
//     createdBy?: string | null;
//     status?: string | null;
//     companyId?: number | null;
//   }
// ): Promise<any> => {
//   try {
//     const response = await apiClient.post(`/Company/${companyId}/ticket`, {
//       title: ticketData.title,
//       description: ticketData.description,
//       type: ticketData.type,
//       priority: ticketData.priority,
//       createdBy: ticketData.createdBy || null,
//       status: ticketData.status || "open",
//       companyId: ticketData.companyId || null,
//     });
//     return response.data;
//   } catch (error) {
//     const axiosError = error as AxiosError<ErrorResponse>;
//     console.error("Erreur lors de la création du ticket :", axiosError.response);
    
//     throw axiosError.response?.data || { message: "Une erreur inattendue est survenue." };
//   }
// };

// // Mise à jour du statut d'un ticket
// export const updateTicketStatus = async (
//   companyId: string,
//   ticketId: string,
//   status: string
// ): Promise<any> => {
//   try {
//     const response = await apiClient.post(`/Company/${companyId}/ticket/${ticketId}/status`, {
//       ticketId: parseInt(ticketId),
//       status: status
//     });
//     return response.data;
    
//   } catch (error) {
//     const axiosError = error as AxiosError<ErrorResponse>;
//     console.error("Erreur lors de la mise à jour du statut du ticket :", axiosError.response);
//     throw axiosError.response?.data || { message: "Une erreur inattendue est survenue." };
//   }
// };

// // Récupération de tous les tickets
// export const getTickets = async (companyId: string): Promise<any> => {
//   try {
//     const response = await apiClient.get(`/Company/${companyId}/ticket`);
//     return response.data;
//   } catch (error) {
//     const axiosError = error as AxiosError<ErrorResponse>;
//     console.error("Erreur lors de la récupération des tickets :", axiosError.response);
//     return axiosError.response?.data || { message: "Une erreur inattendue est survenue." };
//   }
// };

// // Récupération d'un ticket par ID
// export const getTicketById = async (companyId: string, ticketId: string): Promise<any> => {
//   try {
//     const response = await apiClient.get(`/Company/${companyId}/ticket/${ticketId}`);
//     console.log('response',response)
//     return response.data;
    
//   } catch (error) {
//     const axiosError = error as AxiosError<ErrorResponse>;
//     console.error("Erreur lors de la récupération du ticket :", axiosError.response);
//     return axiosError.response?.data || { message: "Une erreur inattendue est survenue." };
    
//   }
  
// };

// // Ajout d'un commentaire à un ticket
// export const addTicketComment = async (
//   companyId: string,
//   ticketId: string,
//   commentData: {
//     author: string;
//     message: string;
//   }
// ): Promise<any> => {
//   try {
//     const response = await apiClient.post(`/Company/${companyId}/ticket/${ticketId}/comment`, {
//       ticketId: parseInt(ticketId),
//       author: commentData.author,
//       message: commentData.message,
//       createdAt: new Date().toISOString()
//     });
//     return response.data;
//   } catch (error) {
//     const axiosError = error as AxiosError<ErrorResponse>;
//     console.error("Erreur lors de l'ajout du commentaire :", axiosError.response);
//     throw axiosError.response?.data || { message: "Une erreur inattendue est survenue." };
//   }
// };

// // Récupération des commentaires d'un ticket
// export const getTicketComments = async (companyId: string, ticketId: string): Promise<any> => {
//   try {
//     const response = await apiClient.get(`/Company/${companyId}/ticket/${ticketId}/comment`);
//     return response.data;
//   } catch (error) {
//     const axiosError = error as AxiosError<ErrorResponse>;
//     console.error("Erreur lors de la récupération des commentaires :", axiosError.response);
//     return axiosError.response?.data || { message: "Une erreur inattendue est survenue." };
//   }
// };

// // Obtenir le nombre de commentaires pour un ticket
// export const getTicketCommentCount = async (companyId: string, ticketId: string): Promise<number> => {
//   try {
//     const response = await apiClient.get(`/Company/${companyId}/ticket/${ticketId}/comment/count`);
//     return response.data.count || 0;
//   } catch (error) {
//     console.error("Erreur lors de la récupération du nombre de commentaires :", error);
//     return 0;
//   }
// };
